import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { WaveLoading } from 'react-loadingg';

import { PageTitle, SimplePopup } from 'components';
import { AddressDBToolbar, AddressDBTable, RegAndEditAddressDB } from './components';

// >> redux
import {
  getAddressDBs,
  addAddressDB,
  updateAddressDB,
  deleteAddressDB,
} from '../../../redux/actions/addressdbs';
// <<

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '120px',
  },
  registerListItemInput: {
    width: '240px',
  },
  registerListItemFilePath: {
    //marginLeft: theme.spacing(2),
    width: '320px',
  },
  registerListItemUpload: {
    marginLeft: theme.spacing(2),
  },
}));

const AddressDB = (props) => {
  const classes = useStyles();

  const {
    addressdbs,
    loading
  } = props;

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [modeRegisterDlg, setModeRegisterDlg] = useState(true);
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);

  const [disableRegisterButton, setDisableRegisterButton] = useState(false);
  const [disableEditButton, setDisableEditButton] = useState(true);
  const [disableDeleteButton, setDisableDeleteButton] = useState(true);

  const [selectedAddressDBs, setSelectedAddressDBs] = useState([]);

  const [editAddressDB, setEditAddressDB] = useState(null);

  const handleClickOpenRegisterDialog = () => {

    setEditAddressDB(null);
    setModeRegisterDlg(true);

    setOpenDialog(true);
  };

  const handleClickOpenEditDialog = () => {

    if (selectedAddressDBs.length !== 1){
      return ;
    }

    const id = selectedAddressDBs[0];
    const selectedAddressDB = addressdbs.find(addressdb => (addressdb.id === id));

    setEditAddressDB(selectedAddressDB);
    setModeRegisterDlg(false);

    setOpenDialog(true);
  };

  const handleClickCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleClickSaveAddressDB = (addressdb) => {

    if (modeRegisterDlg) 
    {
      const newAddressDB = {
        name: addressdb.name,
        file: addressdb.file,
        meter_type: addressdb.meter_type,
        modified_user: addressdb.modified_user,
        modified_at: addressdb.modified_at,
        description: addressdb.description
      };
      //console.log(newAddressDB);
      props.addAddressDB(newAddressDB);
    }
    else if (!modeRegisterDlg && selectedAddressDBs.length === 1)
    {
      //const id = selectedAddressDBs[0];
      const updateAddressDB = {
        id: addressdb.id,
        name: addressdb.name,
        file: addressdb.file,
        modified_user: addressdb.modified_user,
        modified_at: addressdb.modified_at,
        description: addressdb.description,
        prev_file: addressdb.prev_file,
      };
      console.log(updateAddressDB);
      props.updateAddressDB(updateAddressDB.id, updateAddressDB);
    }
    else {
      
    }
    setOpenDialog(false);
  };

  const handleClickOpenDeleteAlert = () => {
    if (selectedAddressDBs.length !== 1){
      return ;
    }
    setOpenDeleteAlert(true);
  };

  const handleSetSelectedAddressDBs = (checks) => {
    setSelectedAddressDBs(checks);
  }

  const handleClickDeleteAlertOk = () => {

    if (selectedAddressDBs.length !== 1){
      return ;
    }

    const id = selectedAddressDBs[0];
    const deleteAddressDB = addressdbs.find(addressdb => (addressdb.id === id));

    props.deleteAddressDB(deleteAddressDB.id);

    setOpenDeleteAlert(false);
  }
  
  const handleClickCloseDeleteAlert = () => {
    setOpenDeleteAlert(false);
  };

  useEffect(() => {
    //console.log("componentDidMount");
    const jwt = localStorage.getItem('jwt');
    //console.log(''+jwt);

    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
      if (decoded.role !== null) {
        setUserRole(decoded.role);
      }
    }

    props.getAddressDBs();

    return () => {
      //console.log("componentDidUnmount");
    };
  }, []); // empty-array means don't watch for any updates


  useEffect(() => {

    //setDisableRegisterButton(addressdbs.length > 0);
    setDisableEditButton(selectedAddressDBs.length !== 1);
    setDisableDeleteButton(selectedAddressDBs.length < 1);

  }, [selectedAddressDBs]);

  if (loading) {
    return <WaveLoading />;
  }

  return (
    <div className={classes.root}>

      <PageTitle 
        pageTitle={'지역DB'}
      />

      <AddressDBToolbar 
        userRole={userRole}
        onClickOpenRegisterDialog={handleClickOpenRegisterDialog}
        onClickOpenEditDialog={handleClickOpenEditDialog}
        onClickOpenDeleteDialog={handleClickOpenDeleteAlert}
        disableRegisterButton={disableRegisterButton}
        disableEditButton={disableEditButton}
        disableDeleteButton={disableDeleteButton}
        />

      <div className={classes.content}>
        <AddressDBTable 
          addressdbs={addressdbs} 
          onSetSelectedAddressDBs={handleSetSelectedAddressDBs}
          />
      </div>

      <RegAndEditAddressDB
        openDialog={openDialog}
        onClickCloseDialog={handleClickCloseDialog}
        onClickSaveAddressDB={handleClickSaveAddressDB}
        editAddressDB={editAddressDB}
        modeRegisterDlg={modeRegisterDlg}
        userName={userName}
        />

      <SimplePopup
        title={`지역DB를 삭제하시겠습니까?`} 
        openPopup={openDeleteAlert} 
        onClickClose={handleClickCloseDeleteAlert} 
        onClickOk={handleClickDeleteAlertOk}
        />
        
    </div>
  );
};

AddressDB.propTypes = {
  loading: PropTypes.bool,
  addressdbs: PropTypes.arrayOf(PropTypes.object),
};

AddressDB.defaultProps = {
  loading: false,
  addressdbs: [],
};

const mapStateToProps = state => ({
  loading: state.addressdbs.loading,
  addressdbs: state.addressdbs.addressdbList,
});

const mapDispatchToProps = dispatch => ({
  getAddressDBs: () => {getAddressDBs(dispatch)},
  addAddressDB: (category) => {addAddressDB(category, dispatch)},
  updateAddressDB: (id, category) => {updateAddressDB(id, category, dispatch)},
  deleteAddressDB: (id) => {deleteAddressDB(id, dispatch)},
})
  
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddressDB);